// extracted by mini-css-extract-plugin
export default {"modal-template-date-range":"styles_modal-template-date-range__z3TAm"};